export default "__VITE_PUBLIC_ASSET__467a6ced__"